/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import ContentContainer from '@/components/AZCustomComponent/ContentContainer';
import PartCard from '@/components/AZCustomComponent/PartCard';
import Title from '@/components/AZCustomComponent/Title';
import { Grid } from '@/components/Grid';
import { clickTrack } from '@/utils/analytics/clickTrack';
import React from 'react';
import { type PopularPartsItem } from '../../interface';
import styles from './styles.module.scss';
import { type CategoryV2 as Category } from '@/features/topNav';

const trackMostPopularPartsInteraction = (linkName: string) => {
  clickTrack({
    mostPopularPartsLinkName: linkName,
    eventType: 'categoryMostPopularPartsInteraction',
  });
};

type Props = {
  data: {
    topTwelvemostPopularPartTypes?: PopularPartsItem[] | Category[];
    name: string;
  };
};
const totalItemCount = 12;

export const MostPopularParts = ({ data }: Props) => {
  if (!data) {
    return null;
  }

  const { topTwelvemostPopularPartTypes, name } = data;

  const handleLinkClick = (linkName: string) => {
    trackMostPopularPartsInteraction(linkName);
  };

  const mostPopularData = topTwelvemostPopularPartTypes?.slice(0, totalItemCount);

  return (
    <ContentContainer type="simple" withMargin>
      {topTwelvemostPopularPartTypes?.length ? (
        <Title variant="md" firstText={name} underline />
      ) : null}
      {mostPopularData != null && mostPopularData.length > 0 ? (
        <Grid
          isULTag
          container
          spacing={0}
          className={styles.container}
          data-testid="most-popular-parts-list"
        >
          {mostPopularData.map((item) => (
            <PartCard part={item} actionHandler={handleLinkClick} key={item.label} />
          ))}
        </Grid>
      ) : null}
    </ContentContainer>
  );
};
